import { Link } from 'react-router-dom';
import { FiLinkedin, FiTwitter, FiFacebook, FiInstagram } from 'react-icons/fi';

// Wizard Logo SVG Component
const WizardLogoSmall = () => (
  <svg width="40" height="40" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="48" fill="#2E5A80"/>
    <path d="M50 15 L55 40 L70 25 L58 45 L85 50 L58 55 L70 75 L55 60 L50 85 L45 60 L30 75 L42 55 L15 50 L42 45 L30 25 L45 40 Z" fill="#F5A623"/>
    <circle cx="50" cy="50" r="12" fill="#2196DF"/>
    <path d="M45 48 L48 52 L55 46" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-4">
            <Link to="/" className="d-flex align-items-center gap-2 text-decoration-none mb-4">
              <WizardLogoSmall />
              <span className="navbar-brand mb-0">
                <span style={{ color: '#9DD1F1' }}>GetJobs</span>
                <span style={{ color: '#F5A623' }}>Wiz</span>
                <span style={{ color: '#7A9AB8', fontSize: '0.8rem' }}>.com</span>
              </span>
            </Link>
            <p className="mb-4" style={{ color: 'rgba(255,255,255,0.7)' }}>
              Find your dream job with a touch of magic! Our platform connects talented professionals with amazing opportunities.
            </p>
            <div className="d-flex gap-3">
              <a href="#" className="text-white-50"><FiLinkedin size={20} /></a>
              <a href="#" className="text-white-50"><FiTwitter size={20} /></a>
              <a href="#" className="text-white-50"><FiFacebook size={20} /></a>
              <a href="#" className="text-white-50"><FiInstagram size={20} /></a>
            </div>
          </div>

          <div className="col-6 col-lg-2">
            <h5>For Job Seekers</h5>
            <ul>
              <li><Link to="/jobs">Browse Jobs</Link></li>
              <li><Link to="/companies">Companies</Link></li>
              <li><Link to="/salary-guide">Salary Guide</Link></li>
              <li><Link to="/career-advice">Career Advice</Link></li>
              <li><Link to="/resume-builder">Resume Builder</Link></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <h5>For Employers</h5>
            <ul>
              <li><Link to="/employer/post-job">Post a Job</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/employer/solutions">Hiring Solutions</Link></li>
              <li><Link to="/employer/resources">Resources</Link></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <h5>Company</h5>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/press">Press</Link></li>
              <li><Link to="/careers">Careers</Link></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <h5>Support</h5>
            <ul>
              <li><Link to="/help">Help Center</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
              <li><Link to="/accessibility">Accessibility</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="mb-0">© {currentYear} GetJobsWiz.com. All rights reserved. Made with ✨ magic for job seekers everywhere.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
